The top and bottom 10 contributors across the time period analyzed are shown.
